module.exports = __webpack_public_path__ + "media/A1.352f0ea6.mp3";